import { render, staticRenderFns } from "./appealList.vue?vue&type=template&id=1cb5e4d7&"
import script from "./appealList.vue?vue&type=script&lang=js&"
export * from "./appealList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports